import { DropDownButton } from '@campx-org/shared'
import { ExitToAppOutlined, HttpsOutlined } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { avatarImage } from 'assets/images'
import ChangePassword from './ChangePassword'
import logout from './logout'
import { StyledUser } from './styles'

export default function UserBox({
  username,
  profileIcon,
}: {
  username: string
  profileIcon: string
}) {
  return (
    <>
      <DropDownButton
        anchor={({ open }) => (
          <Box minWidth={'80px'} textAlign="center" onClick={open}>
            <StyledUser>
              <img
                src={profileIcon ?? avatarImage}
                style={{
                  height: '32px',
                  width: '32px',
                  objectFit: 'contain',
                }}
                onError={(e: any) => {
                  e.target.src = avatarImage
                }}
              />
              <Typography variant="h6">{username}</Typography>
            </StyledUser>
          </Box>
        )}
        menu={[
          {
            label: 'Change Password',
            actionType: 'dialog',
            icon: <HttpsOutlined />,
            content: ({ close }) => <ChangePassword close={close} />,
            contentTitle: 'Change Password',
          },
          {
            label: 'Logout',
            icon: <ExitToAppOutlined />,
            onClick: logout,
          },
        ]}
        menuProps={{
          PaperProps: { sx: { top: '64px !important' } },
        }}
      />
    </>
  )
}
